import { format, formatDistance, formatDistanceToNow, parse, parseISO } from 'date-fns'


export const parseTimestamp = (dateStr: string) => {
  if (!dateStr) return null;

  let _dateval = null;
  
  try {
    _dateval = parseISO(dateStr);
  } catch (err) {
    // do nothing
    console.error(err);
  }

  if (! _dateval) {
    try {
      _dateval = parse(dateStr, 'MMM d, yyyy h:mm:ss a', Date.now());
    } catch (err) {
      // do nothing
    }
  }  
  return _dateval;
}

export const showDate = (dateStr: string, dateFormat?: string) => {
  let _show = dateStr;

  if (! dateStr) {
    return _show;
  }

  try {
    const _dtval = parseTimestamp(dateStr);
    if (! _dtval) {
      return _show;
    }

    if (dateFormat === 'inspectionDate') {
      let _time = format(_dtval, "HHmm");
      switch(_time) {
        case "0900":
          return format(_dtval, 'MMM d, yyyy') + " Half Day (AM)";
        case "1200":
          return format(_dtval, 'MMM d, yyyy') + " Full Day";
        case "1500":
          return format(_dtval, 'MMM d, yyyy') + " Half Day (PM)";
        default:
          return format(_dtval, 'MMMM d yyyy h:mm aa');
      }
    }

    let _format = 'MMM d, yyyy h:mm a';
    switch(dateFormat) {
      case 'dateOnly':
        _format = 'MMM d, yyyy';
        break;
      case 'dateTime':
        _format = 'MMMM d yyyy h:mm aa';
        break;
      default:
        if (dateFormat) {
          _format = dateFormat;
        }
        break;
    }
    _show = format(_dtval, _format);
  } catch (err) {
    // do nothing
    console.error(err);
  }
  return _show;
}

export const showInterval = (laterDate: string, earlierDate: string) => {
  let lateDt = parseTimestamp(laterDate);
  let earlyDt = parseTimestamp(earlierDate);

  if (! (lateDt && earlyDt)) return '';

  return formatDistance(lateDt, earlyDt);
}

export const showElapsed = (pastDate: string) => {

  const pastDt = parseTimestamp(pastDate);
  if (! pastDt) return '';

  return formatDistanceToNow(pastDt, { addSuffix: true });
}


export const getErrorMessage = (err: any) => {
  const _type = typeof err;
  let msg = '';
  if ( _type === 'string') {
    msg = err;
  } else if (_type === 'object') {
    if (err.response && err.response.data) {
      if (err.response.data.message) {
        msg = err.response.data.message;
      /*
      } else if (err.response.data instanceof Blob) {
        msg = getResponseMessage(err.response.data);
      */
      } else {
        msg = "Invalid response message.";
      }
    } else if (err.message) {
      msg = err.message;
    } else {
      msg = "Invalid JSON response.";
      console.error('Unhandled error type', _type, err);
    }
  } else {
    console.error('Unhandled error type', _type, err);
  }

  return msg;
}


export const generatePagination = (cnt: number) => {

  if (! cnt) return null;

  const chunk = 30;

  const last_page = Math.ceil(cnt /chunk);

  return {
    page: 1,
    first_page_url: "/?page=1",
    from: 1,
    last_page,
    links: [
      {
        "url": null,
        "label": "&laquo; Previous",
        "active": false,
        "page": null
      },
      {
        "url": "/?page=1",
        "label": "1",
        "active": true,
        "page": 1
      },
      {
        "url": "/?page=2",
        "label": "2",
        "active": false,
        "page": 2
      },
      {
        "url": "/?page=3",
        "label": "3",
        "active": false,
        "page": 3
      },
      {
        "url": "/?page=2",
        "label": "Next &raquo;",
        "active": false,
        "page": 2
      }
    ],
    next_page_url: "/?page=2",
    items_per_page: chunk,
    prev_page_url: null,
    to: chunk,
    total: cnt
  }
}


export const handleNumInput = (e: any) =>  {
  if (! (e && e.key)) return false;

  const num_chars = "0123456789.";
  const nav_keys = ['Tab','Enter','Esc','Escape','Backspace','Home','End','Delete','Del','Insert','Ins', 'ArrowLeft','ArrowRight'];
  if (! (num_chars.indexOf(e.key) > -1 || nav_keys.indexOf(e.key) > -1)) {
    e.preventDefault();
    return false;
  }
}



export const number_format = (number:any, decimals = 0, decPoint?: string, thousandsSep?: string) => { // eslint-disable-line camelcase
  //  discuss at: https://locutus.io/php/number_format/
  // original by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
  // improved by: Kevin van Zonneveld (https://kvz.io)
  // improved by: davook
  // improved by: Brett Zamir (https://brett-zamir.me)
  // improved by: Brett Zamir (https://brett-zamir.me)
  // improved by: Theriault (https://github.com/Theriault)
  // improved by: Kevin van Zonneveld (https://kvz.io)
  // bugfixed by: Michael White (https://getsprink.com)
  // bugfixed by: Benjamin Lupton
  // bugfixed by: Allan Jensen (https://www.winternet.no)
  // bugfixed by: Howard Yeend
  // bugfixed by: Diogo Resende
  // bugfixed by: Rival
  // bugfixed by: Brett Zamir (https://brett-zamir.me)
  //  revised by: Jonas Raoni Soares Silva (https://www.jsfromhell.com)
  //  revised by: Luke Smith (https://lucassmith.name)
  //    input by: Kheang Hok Chin (https://www.distantia.ca/)
  //    input by: Jay Klehr
  //    input by: Amir Habibi (https://www.residence-mixte.com/)
  //    input by: Amirouche
  //   example 1: number_format(1234.56)
  //   returns 1: '1,235'
  //   example 2: number_format(1234.56, 2, ',', ' ')
  //   returns 2: '1 234,56'
  //   example 3: number_format(1234.5678, 2, '.', '')
  //   returns 3: '1234.57'
  //   example 4: number_format(67, 2, ',', '.')
  //   returns 4: '67,00'
  //   example 5: number_format(1000)
  //   returns 5: '1,000'
  //   example 6: number_format(67.311, 2)
  //   returns 6: '67.31'
  //   example 7: number_format(1000.55, 1)
  //   returns 7: '1,000.6'
  //   example 8: number_format(67000, 5, ',', '.')
  //   returns 8: '67.000,00000'
  //   example 9: number_format(0.9, 0)
  //   returns 9: '1'
  //  example 10: number_format('1.20', 2)
  //  returns 10: '1.20'
  //  example 11: number_format('1.20', 4)
  //  returns 11: '1.2000'
  //  example 12: number_format('1.2000', 3)
  //  returns 12: '1.200'
  //  example 13: number_format('1 000,50', 2, '.', ' ')
  //  returns 13: '100 050.00'
  //  example 14: number_format(1e-8, 8, '.', '')
  //  returns 14: '0.00000001'
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
  const n = !isFinite(+number) ? 0 : +number
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  const dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  let s:any = ''
  const toFixedFix = function (n: any, prec: any) {
    if (('' + n).indexOf('e') === -1) {
      //@ts-ignore
      return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
    } else {
      const arr = ('' + n).split('e')
      let sig = ''
      if (+arr[1] + prec > 0) {
        sig = '+'
      }
      //@ts-ignore
      return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
    }
  }
  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
  if (s[0].length > 3) {
    //@ts-ignore
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    //@ts-ignore
    s[1] = s[1] || ''
    //@ts-ignore
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  //@ts-ignore
  return s.join(dec)
}



export const array_fill_keys = (keys: Array<string>, value: any) => {
  //  discuss at: https://locutus.io/php/array_fill_keys/
  // original by: Brett Zamir (https://brett-zamir.me)
  // bugfixed by: Brett Zamir (https://brett-zamir.me)
  //   example 1: var $keys = {'a': 'foo', 2: 5, 3: 10, 4: 'bar'}
  //   example 1: array_fill_keys($keys, 'banana')
  //   returns 1: {"foo": "banana", 5: "banana", 10: "banana", "bar": "banana"}

  const retObj: any = {}
  let key = ''

  for (key in keys) {
    retObj[keys[key]] = value
  }

  return retObj;
}

// wait for delay
// await sleep(3000);
export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export function isValidString(val: unknown): val is string {
  return typeof val === 'string' && val.trim().length > 0;
}

export function isPopulatedArray<T>(
  arr: T[] | readonly T[] | null | undefined
): arr is [T, ...T[]] {
  return Array.isArray(arr) && arr.length > 0;
}

export function isNotEmpty(obj: Record<string, any>) {
  return Boolean(obj && Object.keys(obj).length > 0);
};

export const pluralize = (word: string, count: number) => {
  if (count === 1) {
    return `1 ${word}`;
  }

  let numstr = number_format(count, 0);

  if (word.match(/[^aeiou]y$/)) {
    return `${numstr} ${word.slice(0,-1)}ies`;
  }

  if (word.match(/^(.*)(s|x|z|sh|ch)$/)) {
    return `${numstr} ${word}es`;
  }
  return `${numstr} ${word}s}`;
}


// check for Changed field value
export const fieldChanged = (dat: any, name: string | Array<string>) => {

  if (! (dat && typeof(dat) === 'object')) return false;

  let fields = Array.isArray(name) ? name  : [name];
  let response = false;

  // @ts-ignore
  fields.forEach( field => {
    if (dat.hasOwnProperty(`${field}Changed`) && dat[`${field}Changed`]) {
      response = true;
    }
  });

  return response;
}